<template>
  <div>
    <v-expansion-panels class="mb-4">
      <v-expansion-panel>
        <v-expansion-panel-header>
          <span>
            Learn About Holiday &amp; Closure Records (Click to expand)
          </span>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <h4>What is a Holiday &amp; Closure Record?</h4>
          <p>
            A Holiday &amp; Closure Record represents specific dates when your
            organization is closed or observes a holiday. Adding these records
            ensures that the scheduling application accurately reflects when
            services or operations are unavailable. This helps in planning and
            avoids scheduling conflicts.
          </p>
          <p>
            <strong>Note:</strong> After adding or updating a closure, all
            existing schedules on those dates will be canceled. All new
            schedules will automatically skip the dates that are part of the
            closure dates, ensuring that no appointments or services are
            scheduled during closed periods.
          </p>
          <p>
            <strong>Notification Option:</strong> You have the option to send
            notifications to all teachers and students who have schedules
            affected by the closure. This feature ensures that everyone is
            informed and can make necessary adjustments to their plans.
          </p>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <div class="d-flex justify-space-between">
      <v-btn icon class="ma-2" @click="$refs.calendar.prev()">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <span class="text-subtitle-2 my-auto" v-if="$refs.calendar">
        {{ $refs.calendar.title }}
      </span>
      <v-btn icon class="ma-2" @click="$refs.calendar.next()">
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </div>
    <v-calendar
      ref="calendar"
      v-model="focus"
      :events="cancellations"
      @click:event="editRecord"
      @change="fetchCancellations"
    ></v-calendar>
    <div class="text-center ma-4">
      <v-btn color="primary" text @click="addNew">
        Add New Closure or Holiday
      </v-btn>
    </div>
  </div>
</template>

<script>
import { EventBus } from "@/EventBus.js";
import dialogMixin from "./dialogMixin";

export default {
  mixins: [dialogMixin],
  data() {
    return {
      currentView: { start: null, end: null },
      cancellations: [],
      focus: new Date().toISOString().substr(0, 10), // Today's date
    };
  },
  created() {
    EventBus.$on("reload-dialog", (uuID) => {
      if (uuID == this.uuID) {
        this.reloadCalendar();
      }
    });
  },
  beforeDestroy() {
    EventBus.$off("reload-dialog");
  },
  methods: {
    handleCalendarChange(view) {
      // Update currentView with the new view range
      this.currentView.start = view.start.date;
      this.currentView.end = view.end.date;
      // Call fetchCancellations with the new view
      this.fetchCancellations(view);
    },
    reloadCalendar() {
      // Trigger fetchCancellations manually
      this.fetchCancellations(this.currentView);
    },
    fetchCancellations(view) {
      // Check if the view parameter is provided by the event
      if (view) {
        this.currentView = view;
        const params = {
          size: 300,
          page: 0,
          startDate: view.start.date, // View start date
          endDate: view.end.date, // View end date
        };
        this.$axios
          .get("/cancellation-master", { params })
          .then((response) => {
            // Map the received data to the events format
            this.cancellations = response.data.content.map((record) => ({
              id: record.id,
              name: record.reason, // Using reason as the label
              start: record.date,
              end: record.date,
              description: record.description, // Additional fields if required
              isGlobal: record.isGlobal,
              // Any other fields you want to include
            }));
          })
          .catch((error) => {
            console.error(
              "An error occurred while fetching cancellations:",
              error
            );
          });
      }
    },
    addNew() {
      const title = "New Holiday & Closure";
      const mode = "HolidayClosureForm";
      const data = {};
      const parentID = this.uuID;
      EventBus.$emit("open-dialog", title, mode, data, parentID);
    },
    editRecord(item) {
      const title = "Edit Holiday & Closure";
      const mode = "HolidayClosureForm";
      const data = {
        id: item.event.id,
      };
      const parentID = this.uuID;
      EventBus.$emit("open-dialog", title, mode, data, parentID);
    },
  },
};
</script>

<style>
button[disabled] {
  color: #aaa;
  cursor: not-allowed;
}
</style>
